module.exports = __webpack_public_path__ + "img/test2.854295b1.png";